var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14.625H10.875M2.625 14.625V4.875C2.625 3.63236 3.63236 2.625 4.875 2.625H8.625C9.86764 2.625 10.875 3.63236 10.875 4.875V5.625M2.625 14.625H1.125M10.875 14.625V5.625M10.875 14.625H15.375M10.875 5.625H13.125C14.3676 5.625 15.375 6.63236 15.375 7.875V14.625M15.375 14.625H16.875M7.875 6.375H5.625M5.625 9.375H7.875",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.0d6f4664b3a2530c9b511dfbe66871b2.svg";
export { ForwardRef as ReactComponent };